import Error500 from "./error-500";

export default Error500;
